export default {
    validate(value) {
        return {
            valid: !!value && value.length > 0,
            required: true
        }
    },
    computesRequired: true
}
